module.exports = new __parcel__URL__("add.b8fea212.png").toString();